/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import AddDocumentContainer from './add.new.participant.document.container';

class AddDocumentModal extends React.Component {
  click(e) {
    e && e.click(); //simulated click to hide the dropdown menu
  }

  render() {
    return (
      <div id="add-new-document-modal">
        <AddDocumentContainer />
      </div>
    );
  }
}

export default AddDocumentModal;
